import { Navigate, Outlet } from 'react-router-dom';
import { useChat } from '../features/chat/hooks/useChat';
import { can } from '../core/permissions/permissions';

/**
 * RequireCapability — route guard for a single capability.
 *
 * This stops someone opening a page by pasting its URL. It is NOT the security boundary:
 * every endpoint behind these pages checks the role on the SERVER as well, because a
 * client-side guard can always be bypassed. This exists so the wrong person sees an
 * honest "no access" instead of a broken screen.
 */
export default function RequireCapability({ capability, fallback = '/dashboard' }) {
  const { currentUser, initializing } = useChat();

  if (initializing) return <div className="flex h-screen items-center justify-center">Loading…</div>;
  if (!currentUser) return <Navigate to="/login" replace />;

  if (!can(currentUser.role, capability)) {
    return (
      <div className="flex h-screen flex-col items-center justify-center bg-slate-100 p-6 text-center">
        <div className="text-2xl font-black text-slate-800">No access</div>
        <p className="mt-2 max-w-sm text-sm text-slate-500">
          Your account does not have permission for this page. Ask an administrator if you
          need it.
        </p>
        <a href={fallback} className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm font-bold text-white">Go back</a>
      </div>
    );
  }
  return <Outlet />;
}
